import { isValidUuidV7 } from '@nudool/shared';

export type NewEventSearch = { brandId?: string; customerId?: string };

function uuidOrUndefined(value: unknown): string | undefined {
  return typeof value === 'string' && isValidUuidV7(value) ? value : undefined;
}

/** A link may open the wizard on a brand, and with it one of that brand's stores; a store alone is dropped, since picking a brand clears it. */
export function parseNewEventSearch(search: Record<string, unknown>): NewEventSearch {
  const brandId = uuidOrUndefined(search.brandId);
  const customerId = brandId ? uuidOrUndefined(search.customerId) : undefined;
  return { ...(brandId && { brandId }), ...(customerId && { customerId }) };
}
